import { fvDateUtc } from '@fv/dates'
import type { TrackDateTime } from '@fv/models'
import { getTrackEventDate } from '@fv/models/core'

export const normalizeTime = (time: string) => {
  return fvDateUtc(`${fvDateUtc().format('YYYY-MM-DD')} ${time}`).format(
    'h:mm A',
  )
}
export const normalizeDate = (date: string) => {
  return fvDateUtc(date).format('MM/DD/YY')
}

interface FormatOpts {
  dateFormat?: string
  timeFormat?: string
  includeTimezone?: boolean
}
export const formatTrackingDateTime = (
  date: TrackDateTime,
  opts: FormatOpts = {},
) => {
  const {
    dateFormat = 'MM/DD/YY',
    timeFormat = 'h:mm A',
    includeTimezone = false,
  } = opts
  if (!date.time) {
    return getTrackEventDate(date).format(dateFormat)
  }
  const fullFormat = `${dateFormat} ${timeFormat}`
  const myDate = getTrackEventDate(date)
  return (
    myDate.format(fullFormat) +
    (date.isUTC && includeTimezone && timeZoneAbbreviation
      ? ` (${timeZoneAbbreviation})`
      : '')
  )
}

export const timeZoneAbbreviation = getTimezoneAbbreviation()
function getTimezoneAbbreviation() {
  return new Intl.DateTimeFormat('en', {
    timeZoneName: 'short',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  })
    .formatToParts(new Date())
    .find(part => part.type === 'timeZoneName')?.value
}
